import { defaultPulseCheckApi, pulseCheck } from '~src/services/ApiController';
import {
  DELETE_ANSWER_FAILED,
  DELETE_ANSWER_REQUEST,
  DELETE_ANSWER_SUCCESS,
  GET_QUESTIONS_FAILED,
  GET_QUESTIONS_REQUEST,
  GET_QUESTIONS_SUCCESS,
  UPDATE_QUESTION_FAILED,
  UPDATE_QUESTION_REQUEST,
  UPDATE_QUESTION_SUCCESS,
} from '~src/modules/questions/constants/actionTypes';
import { AsyncAction } from '~src/services/apiMiddleware';
import { AnswerI, CardI } from '~src/interfaces/question.interface';
import { PackName } from '~src/interfaces/cycle.interface';

export const fetchQuestions = (cycleId: string, type: PackName, precedent?: string): AsyncAction<CardI[], undefined> => ({
  types: [GET_QUESTIONS_REQUEST, GET_QUESTIONS_SUCCESS, GET_QUESTIONS_FAILED],
  callAPI: () => {
    return defaultPulseCheckApi.getQuestions({
      cycleId: cycleId,
      packName: type,
      precedent: precedent,
    })
  },
});

export const updateQuestion = (id: string, answer: AnswerI): AsyncAction<AnswerI, void> => ({
  types: [UPDATE_QUESTION_REQUEST, UPDATE_QUESTION_SUCCESS, UPDATE_QUESTION_FAILED],
  callAPI: () => pulseCheck.put(`/cards/${id}/answer`, answer),
});

export const deleteAnswer = (id: string): AsyncAction<void, { id: string }> => ({
  types: [DELETE_ANSWER_REQUEST, DELETE_ANSWER_SUCCESS, DELETE_ANSWER_FAILED],
  callAPI: () => pulseCheck.delete(`/cards/${id}/answer`),
  payload: { id },
});
